export default __webpack_public_path__ + "static/media/upload.90f7db1a.png";